import {observable, action} from 'mobx'
import {message, notification} from 'antd'

export class Public {
  @observable whitepaper = {
    credentials: {},
    errors: {},
    loading: false,
    modal: false
  }
  @observable contact = {
    credentials: {},
    errors: {},
    loading: false
  }
  constructor(rootStore, api) {
    this.root = rootStore
    this.api = api
  }

  @action showWhitepaperModal = () => {
    this.whitepaper.modal = true
  }

  @action hideWhitepaperModal = () => {
    this.whitepaper.modal = false
  }

  @action changeCredentials = (type, name, value) => {
    this[type].credentials[name] = value
  }

  @action removeError = (type, name) => {
    if (this[type].errors[name]) {
      delete this[type].errors[name]
    }
  }

  @action async downloadWhitepaper() {
    this.whitepaper.loading = true
    const body = Object.assign({}, this.whitepaper.credentials)
    try {
      const {url} = await this.api.req('public/download-whitepaper', 'post', body)
      document.location.href = url
    } catch (e) {
      const errors = e.field_errors
      if (typeof errors === 'object' && errors !== null) {
        for (let name in errors) {
          if (errors[name]) {
            this.whitepaper.errors[name] = errors[name][0].message
          }
        }
      }

      notification['error']({
        message: 'Failed to download',
        description: e.message || 'Unknown error'
      })
    } finally {
      this.whitepaper.loading = false
    }
  }

  @action async sendLetter() {
    this.contact.loading = true
    const body = Object.assign({}, this.contact.credentials)
    try {
      await this.api.req('public/contact-us', 'post', body)
      this.contact.credentials = {}
      message.success('Your message have been sent')
    } catch (e) {
      const errors = e.field_errors
      if (typeof errors === 'object' && errors !== null) {
        for (let name in errors) {
          if (errors[name]) {
            this.contact.errors[name] = errors[name][0].message
          }
        }
      }

      notification['error']({
        message: 'Failed to send letter',
        description: e.message || 'Unknown error'
      })
    } finally {
      this.contact.loading = false
    }
  }
}
